export const Types = {
  GET_DEFECT_REQUEST: 'GET_DEFECT_REQUEST',
  GET_DEFECT_SUCCESS: 'GET_DEFECT_SUCCESS',
  SET_DEFECT_ERROR: 'SET_DEFECT_ERROR',
  SET_SELECTION: 'SET_SELECTION',
  SET_DEFECT_FILTER_KEY: 'SET_DEFECT_FILTER_KEY',
  SET_CURRENT_DEFECT: 'SET_CURRENT_DEFECT',
  RESET_DEFECTS: 'RESET_DEFECTS',
  ADD_DEFECTS: 'ADD_DEFECTS',
  SET_VAT_TYPE: 'SET_VAT_TYPE'
};

export const getDefectRequest = (kulModelKodu, garantiTipi) => ({
  type: Types.GET_DEFECT_REQUEST,
  kulModelKodu,
  garantiTipi,
});

export const setVatType = (vatType) => ({
  type: Types.SET_VAT_TYPE,
  payload: { vatType }
})

export const resetDefects = () => ({
  type: Types.RESET_DEFECTS,
});

export const addDefects = (defects) => ({
  type: Types.ADD_DEFECTS,
  payload: { defects },
});

export const getDefectSuccess = (response) => ({
  type: Types.GET_DEFECT_SUCCESS,
  payload: response,
});

export const setDefectError = (error) => ({
  type: Types.SET_DEFECT_ERROR,
  payload: { error }
});

export const setSelection = (item) => ({
  type: Types.SET_SELECTION,
  payload: { item }
});

export const setDefectFilterKey = (filterKey, level1Selection, level2Selection) => ({
  type: Types.SET_DEFECT_FILTER_KEY,
  payload: {
    filterKey,
    level1Selection: level1Selection || 0,
    level2Selection: level2Selection || 0
  }
});

export const setCurrentDefect = (value) => ({
  type: Types.SET_CURRENT_DEFECT,
  payload: { value }
});
